// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media screen and (max-width:768px){.bambee-logo[data-v-6f5d2cfe] svg{height:50px;width:140px}}@media (hover:hover){.group:hover .mobile-menu-toggle[data-v-6f5d2cfe] .center div,.group:hover .mobile-menu-toggle[data-v-6f5d2cfe] .center:after,.group:hover .mobile-menu-toggle[data-v-6f5d2cfe] .center:before{--tw-bg-opacity:1;background-color:#481d72;background-color:rgba(72,29,114,var(--tw-bg-opacity))}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
